<ngb-rating *ngIf="displayRank; else: displayValue" class="rating" [(rate)]="rank" [readonly]="true" [max]="4">
  <ng-template let-fill="fill">
    <span class="dollar" [class.filled]="fill === 100">$</span>
  </ng-template>
</ngb-rating>
<ng-template #displayValue>
  {{ value | currency }}
</ng-template>
